import { ExportToExcel } from '@/services/excel/generator/excelGenerator';
import ExportExcel from '@/services/excel/generator/exportExcel';
import SheetExcel from '@/services/excel/generator/sheetExcel';
import ColumnExcel from '@/services/excel/generator/columnExcel';

export const columns = [
  new ColumnExcel('Réf. Externe Client', 'refExterneTiers', true),
  new ColumnExcel('Solde Bache', 'soldeBache'),
];

export function templateConfig(data, nameFile, newColumns) {
  return new ExportExcel(`${nameFile || 'TemplateBonStock'}.xlsx`, [
    new SheetExcel('Bon Stock', newColumns || columns, data,
      { skipHeader: false },
    ),
  ]);
}

export function generatedTemplateBonStock() {
  const exemple = {};
  const config = templateConfig([exemple]);
  ExportToExcel(config);
}

export function generatedBonStockFile() {
  const exemple = {
    refExterneTiers: 'S00000',
    soldeBache: 2,
  };
  const config = templateConfig([exemple], 'TemplateBonStock');
  ExportToExcel(config);
}
